import { isEmpty } from "oc-commons/Commons";
import { MAuswahlwert } from "../../metamodell";
import { ZElement } from "./ZElement";
import { partToWorkflow } from "./elementFunctions";

/**
 * Liste von Attributen, auf die die Elemente geprüft werden, ob Hinweistexte enthalten sind
 */
function getPfadeZuHinweistextAuswahlwerten(): string[] {
  return [
    "füllungAuswahlwert",
    "füllungAuswahlwertIndividualisiert",
    "rahmenAuswahlwert",
    "gehflügelAuswahlwert",
    "drückerAuswahlwert",
    "profilzylinderAuswahlwert",
    "öffnungAuswahlwert",
    "anschlagAuswahlwert",
    "füllungsseiteAuswahlwert",
    "anschlagprofilAuswahlwert",
    "anschlagprofilfarbeAuswahlwert",
    "abschlussleisteAuswahlwert",
    "abschlussleisteAuswahlwertIndividualisiert",
    "profilKategorieAuswahlwert",
    "profilAuswahlwert",
    "profilAuswahlwertIndividualisiert",
    "profilleisteAuswahlwert",
    "eAntriebAuswahlwert",
    "aufsatzleisteAuswahlwert",
    "massAuswahlwert",
    "toröffnerAuswahlwert",
    "torschließerAuswahlwert",
  ];
}

/**
 * Hinweis zu Füllungsseite soll nur angezeigt werden bei Elementen, die auch zwei Seiten haben, also
 * prüft diese Methode einen Auswahlwert ob er zur Füllungsseite gehört und ob zwei Füllungsseiten
 * für das Element zur Auswahl stehen
 * @param auswahlwert
 */
function füllungsSeiteFilter(auswahlwert: MAuswahlwert, element: ZElement): boolean {
  return auswahlwert.Auswahl?.Key != "Füllungsseite" || element.meta?.Füllungsseite?.length > 1;
}

/**
 * Geht alle Attribute des CurrentElement durch und prüft ob diese ein Hinweistext haben.
 * Die entsprechenden Auswahlwerte werden gesammelt zurückgegeben
 * @returns Array mit Auswahlwerten
 */
export function getHinweistexteAuswahlwerte(): MAuswahlwert[] {
  const auswahlwerteSetMitHinweistext = new Set<MAuswahlwert>();
  const pfade = getPfadeZuHinweistextAuswahlwerten();

  // Gehe alle Elemente der Szene durch
  APP.arrangement.getElemente().forEach((element) => {
    // Speichere ihre Workflows und Detailserien
    const { DetailSerien, Workflow } = partToWorkflow(element);

    const workflowAuswahlwert = APP.richMetadata.findAuswahlwert(Workflow);
    if (!isEmpty(workflowAuswahlwert?.Hinweistext)) {
      if (element.isMasstor || element.isMasselement)
        // Hinweis zu Zaunelementen und Toren auf Maß darf nur rein, wenn auch wirklich Maßelement vorliegt.
        auswahlwerteSetMitHinweistext.add(workflowAuswahlwert);
    }

    if (!isEmpty(element.eAntriebInfo?.hinweis)) {
      // E-Antrieb Hinweis nur wenn Farbe nicht passt
      auswahlwerteSetMitHinweistext.add(element.eAntriebInfo.antrieb.Auswahlwert);
    }

    DetailSerien.forEach((ds) => {
      const detailSerieAuswahlwert = ds.Auswahlwert;
      if (!isEmpty(detailSerieAuswahlwert?.Hinweistext))
        auswahlwerteSetMitHinweistext.add(detailSerieAuswahlwert);
    });

    // Gehe alle relevanten Auswahlwerte (getPfadeZuHinweistextAuswahlwerten) durch, filtere und sammle sie
    pfade.forEach((pfad) => {
      const auswahlwert = _.get(element, pfad);
      if (!isEmpty(auswahlwert?.Hinweistext) && füllungsSeiteFilter(auswahlwert, element)) {
        auswahlwerteSetMitHinweistext.add(auswahlwert);
      }
    });
  });

  return Array.from(auswahlwerteSetMitHinweistext);
}

/**
 * Wie getHinweistexteAuswahlwerte, nur werden die Keys der Hinweistexte ausgegeben
 */
export function getHinweistexteAuswahlwertKeys(): string[] {
  const auswahlwerteMitHinweistext = getHinweistexteAuswahlwerte();
  return auswahlwerteMitHinweistext.map((x) => x.Key);
}

/**
 * Wie getHinweistexteAuswahlwerte, nur werden die Konkreten Hinweistexte ausgegeben
 */
export function getHinweistexte(): string[] {
  const auswahlwerteMitHinweistext = getHinweistexteAuswahlwerte();
  return auswahlwerteMitHinweistext.map((x) => x.Hinweistext);
}
